<template>
  <div>
    <button
      type="button"
      class="b-pop-up__btn-social b-pop-up__btn-social--facebook"
      @click="onClickLogin">
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
import postRequestHandler from './../../../lib/postRequestHandler'
import { updateUserDisplay } from './../../../lib/lib'
import constants from './../../../lib/constants'

export default {
  props: {
    buttonText: { default: 'Login with Facebook', type: String },
  },
  emits: [
    'loading',
    'closeModal',
    'showModalPendingRegistration',
    'showAlert',
    'hideAlert',
  ],
  data() {
    return {
      userInfo: null,
    }
  },

  mounted() {
    const initializeCallbacks = function (successCallback, errorCallback) {
      const channel = new BroadcastChannel('auth')

      channel.addEventListener(
        'message',
        function (e) {
          if (e.data.provider !== 'facebook') {
            return
          }

          if (e.data.success && successCallback) {
            // eslint-disable-next-line camelcase
            successCallback({ accessToken: e.data.accessToken })
          } else if (
            !e.data.success &&
            errorCallback &&
            e.data.reason.length > 0
          ) {
            errorCallback({ reason: e.data.reason })
          }
        },
        false,
      )
    }

    initializeCallbacks((data) => {
      if (data.accessToken) {
        this.login(data.accessToken)
      } else {
        this.handleError()
      }
    }, this.handleError)
  },

  methods: {
    async onClickLogin() {
      try {
        this.initFacebook()
      } catch (error) {
        console.warn(error.message)
        this.handleError()
      }
      this.$emit('loading', false)
    },

    initFacebook() {
      const { appId, redirectUri } = this.configuration.facebook
      // eslint-disable-next-line prefer-template
      const authUrl =
        'https://www.facebook.com/v2.10/dialog/oauth?' +
        jQuery.param({
          // eslint-disable-next-line camelcase
          response_type: 'code',
          // eslint-disable-next-line camelcase
          client_id: appId,
          // eslint-disable-next-line camelcase
          redirect_uri: redirectUri,
          scope: 'email,public_profile',
        })
      window.open(
        authUrl,
        'facebook-auth',
        'resizable=no,scrollbars=no,width=1200,height=600',
      )
    },

    login(accessToken) {
      this.$emit('loading', true)

      const { endpointSubmitData } = this.configuration.facebook
      const postData = {
        accessToken,
      }

      postRequestHandler({
        postData,
        endpoint: endpointSubmitData,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        captchaAction: this.configuration.captchaAction,
        refreshTokenHandler: this.configuration.refresh,
      })
    },

    handleError() {
      this.$emit('loading', false)
      this.$emit('showAlert', [this.dictionary.defaultErrorMessage])
    },

    handleSuccess(data) {
      this.$emit('loading', false)
      this.$emit('closeModal', true)
      this.$emit('hideAlert')

      const { loggedIn, pendingRegistration } = constants.socialLogin.status
      const { status, redirectUrl } = data.data

      switch (status.toLowerCase()) {
        case loggedIn:
          this.handleSuccessLoggedIn(data)
          break
        case pendingRegistration:
          this.handleSuccessPendingRegistration()
          break
        default:
          console.log(`Sorry, we are out of ${status}.`)
      }

      if (redirectUrl) {
        window.location.assign(redirectUrl)
      }
    },

    handleSuccessLoggedIn(data) {
      const { accountData } = data.data

      if (accountData) {
        const { firstName, fullName, lastName, avatar } = accountData
        updateUserDisplay({ img: avatar?.url, firstName, fullName, lastName })

        document.dispatchEvent(
          new CustomEvent('login-was-held', {
            detail: { accountData },
          }),
        )
        window.location.reload()
      }
    },

    handleSuccessPendingRegistration() {
      this.$emit('showModalPendingRegistration', false)
    },
  },
}
</script>
